<template>
	<table id="conversions" class="grid">
		<tbody>
			<tr
				v-for="(unit, index) in units"
				:key="'unit-'+index"
				:class="{selected : selected === unit.code}"
			>
				<td>{{$t(unit.name)}}</td>
				<td>{{unit.value | unit}}</td>
				<td>{{$t(unit.description)}}</td>
			</tr>
		</tbody>
	</table>
</template>

<script>
export default {
	name: 'YarnCounTable',
	props: ['units', 'selected'],
	filters: {
		unit(value) {
			value = value || 0;
			return value.toPrecision(5);
		}
	}
}
</script>

<style scoped>
</style>
